module.exports = require("@ember/debug");